module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\nvar i18n = require(\'@cdo/netsim/locale\');\n%>\n<div class="netsim-router-tab">\n  <h1><%= i18n.routerTab_stats() %></h1>\n  <div class="router-stats"></div>\n  <% if (locals.level.showRouterBandwidthControl) { %>\n    <h1><%= i18n.routerTab_bandwidth() %></h1>\n    <div class="bandwidth-control"></div>\n  <% } %>\n  <% if (locals.level.showRouterMemoryControl) { %>\n    <h1><%= i18n.routerTab_memory() %></h1>\n    <div class="memory-control"></div>\n  <% } %>\n  <h1><%= i18n.routerTab_logs() %></h1>\n  <span class="netsim-button netsim-button-secondary large-button" id="show-router-log-modal-two"><%= i18n.logBrowserButton() %></span>\n</div>\n', __filename = "src/netsim/NetSimRouterTab.html.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var i18n = require("@cdo/netsim/locale");
        __line = 3;
        __append('\n<div class="netsim-router-tab">\n  <h1>');
        __line = 5;
        __append(escapeFn(i18n.routerTab_stats()));
        __append('</h1>\n  <div class="router-stats"></div>\n  ');
        __line = 7;
        if (locals.level.showRouterBandwidthControl) {
            __append("\n    <h1>");
            __line = 8;
            __append(escapeFn(i18n.routerTab_bandwidth()));
            __append('</h1>\n    <div class="bandwidth-control"></div>\n  ');
            __line = 10;
        }
        __append("\n  ");
        __line = 11;
        if (locals.level.showRouterMemoryControl) {
            __append("\n    <h1>");
            __line = 12;
            __append(escapeFn(i18n.routerTab_memory()));
            __append('</h1>\n    <div class="memory-control"></div>\n  ');
            __line = 14;
        }
        __append("\n  <h1>");
        __line = 15;
        __append(escapeFn(i18n.routerTab_logs()));
        __append('</h1>\n  <span class="netsim-button netsim-button-secondary large-button" id="show-router-log-modal-two">');
        __line = 16;
        __append(escapeFn(i18n.logBrowserButton()));
        __append("</span>\n</div>\n");
        __line = 18;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}